'use strict';

angular.module('atex.dam').directive('damSmartUpdateMultiple', function($compile,$http,$q,ContentService,DamMarkAsService,DamActivityService) {    
  return {
    restrict: 'ACE',
    templateUrl : 'views/dam-smart-updates-multiple.html',
    replace:true,
    scope: {
      showlabel : "=",
      values    : "=",
      buttonEnabled:"="
    },
    link: function (scope, element, attrs) {
      scope.rules = DamMarkAsService.getSmartUpdateRules();

      scope.show = false;

      element.find('button').click(function() {
        dropDownFixPosition($(".smart-updates-button-to-fix"),$(".smart-updates-ul-to-fix"));
      });

      scope.$on('$destroy', function() {
        element.find('button').off("click");
      });

      function dropDownFixPosition(button,dropdown){
        if(button.length > 1) {
          button = angular.element(button[button.length-1]);
        }

        var dropDownTop = button.offset().top + button.outerHeight();
        dropdown.css('top', dropDownTop + "px");
        dropdown.css('left', button.offset().left + "px");
      }

      scope.metadata = function(f,v) {
        return $q(function(resolve) {
          var idlist = [];
          scope.values.forEach(function(value) {
            idlist.push(value.id);
          });
          var locked = false;
          DamActivityService.lock(idlist).then(function(responses){
            locked = true;
            var data = {
                'aspects' : {
                  'contentData' : {
                    'data' : {
                      '_type' : 'com.atex.onecms.app.dam.smartupdates.DamSmartUpdatesMetatadaBean',
                      'id' : JSON.parse(JSON.stringify(idlist)),
                      'field' : f,
                      'value' : v
                    }
                  }
                }
            };
            var url = "/onecms/dam/content/smartupdate/metadata";
            return $http.put(url, data);
          }).then(function(response) {
            scope.error = false;
            DamActivityService.unlock(idlist);
            resolve(response);
          }).then(null, function(error) {
            if (locked) {
              DamActivityService.unlock(idlist);
            }
            scope.error = true;
            resolve(error);
          });
        });
      };

      scope.content = function(f,v) {
        return $q(function(resolve) {
          var idlist = [];
          scope.values.forEach(function(value) {
            idlist.push(value.id);
          });
          var locked = false;
          DamActivityService.lock(idlist).then(function(responses){
            locked = true;
            var updatePromises = idlist.map(function(id) {
              ContentService.getContent({ id: id }).then(function(response) {
                var data = response.data;
                data.aspects.contentData.data[f]=v;
                var transferInfo = { 
                    id: response.id, 
                    data: data,
                    revision: response.revision
                };
                return ContentService.updateContent(transferInfo);
              }).then(null, function(error){
                return undefined;
              });
            });
            return $q.all(updatePromises);
          }).then(function(responses) {
            scope.error = false;
            DamActivityService.unlock(idlist);
            resolve(responses);
          }).then(null, function(error) {
            if (locked) {
              DamActivityService.unlock(idlist);
            }
            scope.error = true;
            resolve(error);
          });
        });
      };

      scope.update = function(f,v) {
        scope.show = true;

        if(f.indexOf('dimension') === 0 ) {
          scope.metadata(f,v).then(function(e) {
            scope.show=false;
          });
        } else {
          scope.content(f,v).then(function(e) {
            scope.show=false;
          });
        }
      };
    }
  };
});
